const COACHING_BENCHMARKS = {
  wpm: {
    min: 130, // minimum WPM that is considered "good" (inclusive)
    max: 175, // maximum WPM that is considered "good" (inclusive)
  },
  // thresholds are in %s (e.g. 4%+ filler words == "negative")
  fillerWordsThresholds: {
    positive: 4,
    neutral: 5, // this value is used for the gradient range
  },
  // thresholds are in instance counts (e.g. 1+ instances == "negative")
  nonInclusiveTermThresholds: {
    positive: 1,
  },
  // thresholds are in instance counts (e.g. 1+ instances == "negative")
  interruptionThresholds: {
    positive: 1,
  },
};

export default COACHING_BENCHMARKS;
